import { render, staticRenderFns } from "./UploadAssetImage.vue?vue&type=template&id=f8ff75f6&"
import script from "./UploadAssetImage.vue?vue&type=script&lang=js&"
export * from "./UploadAssetImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports